import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setDefaultDashboard } from '../../actions/uiPersisted';
import routes from '../../routes';
import LandingDashboard from '../rescuerDashboard/rescuerDashboardMobile/LandingDashboard';
import AdminDashboardDesktop from './AdminDashboardDesktop/AdminDashboardDesktop';
import { currentlyLoggedInOrImpersonatingUserHasRoleInCurrentlySelectedSite } from '../../services/auth';
import { Roles } from '../../models/roles';

const AdminDashboardContainer = ({ isMobileView, match: { params } }) => {
  const dispatch = useDispatch();
  const isAdmin = currentlyLoggedInOrImpersonatingUserHasRoleInCurrentlySelectedSite(Roles.Admin);

  if (!isAdmin) {
    return null;
  }

  useEffect(() => {
    // set as default dashboard
    dispatch(setDefaultDashboard({ route: routes.dashboardAdmin, params }));
  }, [dispatch]);

  if (isMobileView) {
    return <LandingDashboard />;
  }

  return <AdminDashboardDesktop />;
};

export default AdminDashboardContainer;
